import { connect } from 'react-redux';

// import view
import TopLevelCategory from './topLevelCategory';
import { getFeatureFlagsData } from '../../../featureFlags/store/selectors';
// functions to get/set data from redux
import { getProductsStatus, getProductsData } from '../../store/selectors';
// functions to get data from APIs and save to redux
import { loadProducts } from '../../store/action-creators';
import { getProfileData } from "../../../login/store/selectors";
import {
  getPromotionsData,
  getPromotionsStatus,
} from "../../../orderBuilder/store/selectors";
import { loadPromotions } from "../../../orderBuilder/store/action-creators";

//gets data from redux and sets to variables
// NOTE: productsData is actually the full catalogue - categories , sub categories, products
const mapStateToProps = (state) => ({
  featureFlags: getFeatureFlagsData(state),
  productsStatus: getProductsStatus(state),
  productsData: getProductsData(state),
  profileData: getProfileData(state),
  promotionsData: getPromotionsData(state),
  promotionsStatus: getPromotionsStatus(state),
});
// pass the api call function to the view
const mapDispatchToProps = {
  loadProducts,
  loadPromotions,
}

export default connect(mapStateToProps, mapDispatchToProps)(TopLevelCategory);
